import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import { ErrorInfo } from '../../../api/model';
import { usePostManuals } from '../../../api/manual/manual';
import { useDefaultOptions } from '../../../hooks/api';
import { ManualList } from './ManualList';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|マニュアル')}</title>
    </Helmet>
  );
}

type SearchProps = {
  comment?: string;
};
function ManualListPage() {
  const {
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const [params] = useSearchParams();
  const [conditions, setCondition] = useState<SearchProps>({});
  const { mutateAsync, data } = usePostManuals<AxiosError<ErrorInfo>, unknown>(options);

  useEffect(() => {
    const searchCondition: SearchProps = {};

    searchCondition.comment = params.get('comment') || undefined;

    setCondition(searchCondition);
  }, [params]);

  const handleSearch = useCallback(() => {
    const postManuals = async () => {
      await mutateAsync({ data: { file_name: conditions.comment } });
    };
    void postManuals();
  }, [conditions.comment, mutateAsync]);

  // 一覧表示
  useEffect(() => {
    handleSearch();
  }, [conditions, handleSearch]);

  return (
    <div id="main">
      <Title />
      <ManualList manuals={data?.data.manual_items || []} onSearch={handleSearch} />
    </div>
  );
}

export default ManualListPage;
